import { map, merge, Observable, of, switchMap, takeUntil, timer } from "rxjs";

export const easeLoading = function <TResult>(pendingState: TResult, observable: Observable<TResult>): Observable<TResult> {
    const startTime = performance.now();

    const minimumWaitTime = 75;
    const deferWaitTime = 400;

    return merge(
        timer(minimumWaitTime).pipe(
            map(() => pendingState),
            takeUntil(observable)
        ),
        observable.pipe(
            switchMap((value) => {
                const elapsedTime = performance.now() - startTime;

                if (elapsedTime < minimumWaitTime || elapsedTime > minimumWaitTime + deferWaitTime) {
                    return of(value);
                }

                return timer(deferWaitTime).pipe(map(() => value));
            })
        )
    );
};
